import { MotionValue } from 'framer-motion';
import { useEffect } from 'react';
import { create } from 'zustand';
import { Anchors, AppNavigation } from '@/shared/lib/types';

export type HeaderAnchorsPayload = {
    anchors: Anchors;
    navigation: AppNavigation;
    scrollYProgress?: MotionValue;
    universal?: boolean;
};

export const useHeaderAnchorsStore = create<{
    headerAnchors: HeaderAnchorsPayload | null;
    setHeaderAnchors: (payload: HeaderAnchorsPayload | null) => void;
}>((set) => ({
    headerAnchors: null,
    setHeaderAnchors: (headerAnchors) => set(() => ({ headerAnchors })),
}));

export const useHeaderAnchorsValue = () => useHeaderAnchorsStore((state) => state.headerAnchors);
export const useSetHeaderAnchors = () => useHeaderAnchorsStore((state) => state.setHeaderAnchors);

export const useHeaderAnchorsEffect = (payload: HeaderAnchorsPayload) => {
    const setHeaderAnchors = useSetHeaderAnchors();

    useEffect(() => {
        setHeaderAnchors(payload);

        return () => {
            setHeaderAnchors(null);
            document.documentElement.style.setProperty('--anchors-height', '0px');
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [payload.anchors, payload.navigation, payload.scrollYProgress, payload.universal, setHeaderAnchors]);
};
